import { useEffect, useState } from 'react'

/**
 * Subscribes to a media query.
 *
 * Used instead of watching `window.innerWidth`, which re-renders on every pixel of a window drag;
 * this fires only when the answer actually changes.
 */
export function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState(() => window.matchMedia(query).matches)

  useEffect(() => {
    const media = window.matchMedia(query)
    const onChange = (): void => setMatches(media.matches)
    onChange()
    media.addEventListener('change', onChange)
    return () => media.removeEventListener('change', onChange)
  }, [query])

  return matches
}
